import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledScrollbar = styled.div`
  height: 100%;
  overflow-y: scroll;
  position: relative;

  /* for Firefox */
  @supports (-moz-appearance: none) {
    scrollbar-width: thin;
    overflow-y: auto;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.secondary60};
    -webkit-border-radius: 1ex;
  }
`

const ScrollArea = ({ children, ...otherProps }) => {
  return (
    <StyledScrollbar {...otherProps}>{children}</StyledScrollbar>
  )
}

ScrollArea.propTypes = {
  children: PropTypes.node,
}

export default ScrollArea
